import React, { Component } from 'react'
import PDFToolbarContainer from './PDFToolbarContainer'
import RelatedResearchContainer from './RelatedResearchContainer'
import ZoomControlContainer from './ZoomControlContainer'
import RatingsControlContainer from './RatingsControlContainer'
import throttle from 'lodash/throttle'

import '../scss/PDFControls.scss'


class PDFControls extends Component {
  
  constructor (props) {
    super(props)
    this.state = {
      display: true,
      displayZoomControls: !('ontouchstart' in window),
      mouseOver: false,
      ratingOptions: this.props.ratingOptions
    }
  }
  
  handleMouseOver = () => {
    clearTimeout(this.displayTimeout)
    this.setState({
      display: true,
      mouseOver: true
    })
  }
  
  handleMouseLeave = () => {
    if (this.props.documentLoaded) {
      this.delayedHide()
    }
  }
  
  delayedHide = (delay) => {
    if (!delay) {
      delay = 3000
    }
    clearTimeout(this.displayTimeout)
    this.displayTimeout = setTimeout(() => {
      this.setState({
        display: false,
        mouseOver: false
      })
    }, delay)
  }

  handleTopHover = (e) => {
    const relativeY = e.clientY / window.innerHeight
    if (relativeY < 0.15) {
      this.setState({
        display: true,
        mouseOver: true
      })
    } else {
      this.delayedHide()
    }
  }

  throttledMouseMove = throttle((e) => {
    this.handleTopHover(e)
  }, 50)

  componentDidMount () {
    window.addEventListener('mousemove', (e) => {
      this.throttledMouseMove(e)
    })

    window.addEventListener('touchstart', (e) => {
      this.handleTopHover(e.changedTouches[e.changedTouches.length - 1])
    })
  }
  
  componentDidUpdate (prevProps, prevState) {
    if ((this.props.documentLoaded && this.props.documentLoaded !== prevProps.documentLoaded) || (this.props.scale !== prevProps.scale && !this.state.mouseOver)) {
      this.setState({
        display: true
      })
      this.delayedHide()
    }
  }

  shouldDisplayZoomControls () {
    return this.state.display && this.state.displayZoomControls
  }

  render () {
    return (
      <div className="PDFControlsContainer">
        <div className="PDFControls" style={{right: this.props.pdfReaderScrollbarWidth}}>
          <PDFToolbarContainer {...this.props} display={this.state.display} pdfReaderScrollbarWidth={this.props.pdfReaderScrollbarWidth} />
          <ZoomControlContainer scale={this.props.scale} onZoomIn={this.props.onZoomIn} onZoomOut={this.props.onZoomOut} display={this.shouldDisplayZoomControls()} />
          {this.props.viewerPermissions && this.props.viewerPermissions.rate &&
            <RatingsControlContainer {...this.props} display={this.state.display} ratingOptions={this.state.ratingOptions}
                                     handleRatingClick={this.props.handleRatingClick} getDocPageWidth={this.props.getDocPageWidth}/>
          }
          {this.props.viewerPermissions && this.props.viewerPermissions.relatedResearch &&
            <RelatedResearchContainer referrer={this.props.referrer} clientActionId={this.props.clientActionId}
                                      startTimestamp={this.props.startTimestamp} permsSignature={this.props.permsSignature} getDocPageWidth={this.props.getDocPageWidth}
                                      handleRelatedResearchClick={this.props.handleRelatedResearchClick} display={this.state.display} />
          }
        </div>
      </div>
    )
  }
}

export default PDFControls
